import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Chart, LineAdvance, Tooltip, Guide, Axis } from 'bizcharts';

const LinearFingerChart = ({
  data = [],
  height = 120,
  mainColor = '#5BE584',
  secondaryColor = '#F16063',
}) => {
  const lastItemIndex = data?.length > 0 ? data.length - 1 : 0;
  const greenOrRedColor =
    data?.[lastItemIndex - 1]?.count < data?.[lastItemIndex - 2]?.count
      ? secondaryColor
      : mainColor;

  if (data.length === 0) {
    return <></>;
  }

  return (
    <Chart
      padding={[0, 0, 0, 0]}
      autoFit
      data={data}
      scale={{ count: { min: 0 } }}
      height={height}
      renderer={'svg'}
    >
      <LineAdvance
        shape='smooth'
        point={false}
        area
        position='point*count'
        color={greenOrRedColor}
      />
      <Tooltip visible={false} />
      <Guide line={{ visible: false }} />
      <Axis name='point' visible={false} />
      <Axis name='count' visible={false} />
    </Chart>
  );
};

LinearFingerChart.propTypes = {
  data: PropTypes.object,
  height: PropTypes.number,
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};

export default memo(LinearFingerChart);
